import { render, staticRenderFns } from "./TaskqueueTemplateForm.vue?vue&type=template&id=68476118&"
import script from "./TaskqueueTemplateForm.vue?vue&type=script&lang=js&"
export * from "./TaskqueueTemplateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports